import { ID, Task, TaskActionType, UpdateTask } from '@griply/types';

export type TaskGoalRestoreAdjustment = {
  taskCount: number;
  completedTaskCount: number;
};

export type BuildTaskRestoreUpdatesOptions = {
  tasks: Task[];
  updateGoals: boolean;
};

export type TaskRestoreUpdates = {
  taskUpdates: UpdateTask[];
  goalAdjustments: Record<ID, TaskGoalRestoreAdjustment>;
  restoredTasks: Task[];
};

export const buildTaskRestoreUpdates = ({
  tasks,
  updateGoals,
}: BuildTaskRestoreUpdatesOptions): TaskRestoreUpdates => {
  const restoredTasks = tasks.filter(({ deletedAt }) => !!deletedAt);

  const goalAdjustments: Record<ID, TaskGoalRestoreAdjustment> = {};
  if (updateGoals) {
    restoredTasks.forEach((task) => {
      if (!task.goalId || task.action?.type === TaskActionType.GoalTimeslot) {
        return;
      }
      const current = goalAdjustments[task.goalId] ?? {
        taskCount: 0,
        completedTaskCount: 0,
      };
      current.taskCount += 1;
      if (task.completedAt) {
        current.completedTaskCount += 1;
      }
      goalAdjustments[task.goalId] = current;
    });
  }

  const taskUpdates: UpdateTask[] = restoredTasks.map(({ id }) => ({
    id,
    deletedAt: null,
    archivedAt: null,
  }));

  return { taskUpdates, goalAdjustments, restoredTasks };
};
